import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
const ProductListItems = styled.div `
  display: flex;
  justify-content: flex-start;
  font-size: 20px;

  span:first-child {
    font-style: normal;
    font-weight: 500;
    min-width: 20px;
    margin-right: 10px;
    text-align: right;
  }
`;
export const Products = ({ productList }) => {
    const products = Object.entries(productList).map(([key, value]) => (_jsxs(ProductListItems, { children: [_jsx("span", { children: value }), _jsx("span", { children: key })] }, key)));
    return products;
};
